// Translations
import accessKeyInformationForm from '../components/access-key-information-form/translations/en'

// Translation: Model > Access key manager > Access key managing dialog (English)
export default Object.freeze({
	actions: {
		cancel: 'Cancel',
		create: 'Create',
		save: 'Save'
	},
	components: { accessKeyInformationForm },
	message: {
		text: {
			information: 'Your access key is generated but this is the only time you can see it. When you close this dialog, you will not be able to view it again.',
			instructions: 'Please save this secret key somewhere safe. If you lose it, you will need to create a new one. Additionally, you should not be exposing it anywhere.'
		},
		title: 'Be careful!'
	},
	title: {
		creating: 'Create access key',
		editing: 'Edit access key'
	}
})
